import { createFileRoute } from '@tanstack/react-router';

import { Campaign, CampaignSearchParamsSchema } from '@/features/trafficking';

export const Route = createFileRoute('/_app/trafficking/campaign')({
  validateSearch: CampaignSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <Campaign />;
}
